module.exports = __webpack_public_path__ + "img/casitaMobile.d1fc76d2.svg";